import { IArticleContentful } from "@/interfaces/IArticleContentful.interface";
import { constrainedMemory } from "process";

export const parseDate = (date: string) => {
  const newDate = new Date(date);
  return newDate.toLocaleString(`es-MX`, {
    day: `numeric`,
    year: `numeric`,
    month: `long`,
  });
};


type BlogPostContent = {
  nodeType: string;
  content: BlogPostContent[]
  value: string;
}

const unwrapFn = (el: BlogPostContent): string[] => el.nodeType === 'text'
  ? [el.value]
  : el.content.flatMap((inside: BlogPostContent) => unwrapFn(inside))

export const getPostContentWordCount = (blogPostContent: BlogPostContent) => {
  return unwrapFn(blogPostContent).reduce((wordCount, content) => wordCount + (content?.match(/\S+/g)?.length ?? 0), 0)
}

export const getReadingTime = (blogPostContent: BlogPostContent) => Math.floor((getPostContentWordCount(blogPostContent) ?? 0) / 230)